import type { SlideProps } from "@/engine/types";
import { GradientText, Reveal, RevealItem, RevealList, SlideShell } from "@/ui";

/** The walk order of the whole session, from the intro bullets. */
const TOPICS = [
  "Page strength",
  "On-page",
  "Off-page",
  "Technical",
  "Local",
  "Mobile",
  "Content",
  "E-commerce",
  "Keywords",
  "SERPs",
  "Risks",
  "Defense",
] as const;

export function AgendaSlide({ active }: SlideProps) {
  return (
    <SlideShell chapter={1} title="What we'll cover" align="center">
      <div className="mx-auto flex w-full max-w-6xl flex-col items-center gap-16">
        {/* Topic chip wall, in walk order */}
        <RevealList
          active={active}
          stagger={0.1}
          delay={0.25}
          className="flex max-w-5xl flex-wrap items-center justify-center gap-5"
        >
          {TOPICS.map((topic, i) => (
            <RevealItem key={topic}>
              <div className="glass group flex items-center gap-4 px-7 py-4 transition-transform duration-300 hover:-translate-y-1">
                <span className="font-mono text-xl text-accent-cyan/70">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="font-display text-2xl font-semibold text-white/90">
                  {topic}
                </span>
              </div>
            </RevealItem>
          ))}
        </RevealList>

        {/* Goal line */}
        <Reveal active={active} delay={1.7} y={24}>
          <p className="max-w-5xl text-3xl leading-relaxed text-white/80">
            <GradientText className="font-semibold">Checklists and vocabulary</GradientText> —
            for the next chapters, and for talking to SEO and product partners.
          </p>
        </Reveal>
      </div>
    </SlideShell>
  );
}
